import React, {Component} from "react";
import planoImgSQ from "../../../assets/preview/plano-cuadrado.png";
import BolsaLaminaTitle from "../title-preview/bolsa-lamina-title";

class PlanoCuadro extends Component {
    render() {
        const jsonObj = this.props.jsonObj;

        return (
            <div className={"pl-image-cuadro"}>
                <BolsaLaminaTitle jsonObj={jsonObj} />
                <div className={"preview-image pt-5"}>
                    <div>
                        <span>{jsonObj.dimensiones.largo} {jsonObj.dimensiones.unidad}</span>
                        <img src={ planoImgSQ } alt={"preview"}/>
                    </div>
                    <div style={{paddingLeft:"15%", marginTop:"-18px"}}>{jsonObj.dimensiones.ancho} {jsonObj.dimensiones.unidad}</div>
                </div>
            </div>
        );
    }
}

export default PlanoCuadro;